<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2022-05-06 08:43:22
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-04-01 14:28:46
 * @FilePath: \jzjy\src\views\Login\login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container">
    <!-- 首页接受参数，判断是否更新 -->
    <div class="upDateBox">
      <h3>温馨提示</h3>
      <p>
        您好，原精准教研教学平台手机端已升级为微信小程序：功能更全面，体验更流畅！请长按下方小程序码授权登录即可继续使用，任何疑问也可以联系我们的客服处理。（工作日9:00-18:00）感谢您的支持！
      </p>
      <div class="pic">
        <div class="evm">
          <img :src="kf_file_url" alt="" />
          <span>客服微信</span>
        </div>
        <div class="evm">
          <img :src="xcx_file_url" alt="" />
          <span>小程序码</span>
        </div>
      </div>
      <!-- <div class="liaojie" @click="reday">我已了解</div> -->
    </div>
  </div>
</template>

<script>
import {
  login,
  qiniuconfig,
  wxdlewm,
  upwxdl,
  sendverf,
  sysinfo,
} from "../../api/http";
export default {
  data() {
    return {
      //新加内容
      isUpdateShow: true, //更新弹窗
      kf_file_url: "", //客服微信
      xcx_file_url: "", //小程序码
    };
  },
  created() {
    // 系统信息
    console.log(this.$route.query, "首页接受参数判断是否弹窗");
    // if (this.$route.query.tk) {
    //   this.isUpdateShow = true;
    // } else {
    //   this.isUpdateShow = false;
    // }
    sysinfo().then((res) => {
      // console.log(res, "右侧悬浮窗");
      this.kf_file_url = res.retRes.kf_file_url;
      this.xcx_file_url = res.retRes.xcx_file_url;
    });
  },

  methods: {
    //我知道了
    reday() {
      this.isUpdateShow = false;
    },
  },
};
</script>
<style lang="less" scoped>
.container {
    background: #FFF;
    height: 100%;
    box-sizing: border-box;
  //首页更新提醒弹窗
  .upDateBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-top: 5vh;
    h3 {
      margin-bottom: 15px;
      font-size: 16px;
      text-align: center;
      color: #333;
    }
    p {
      margin: 0 auto;
      padding: 0 15px;
      margin-bottom: 8vh;
      font-size: 12px;
      line-height: 20px;
      color: #666;
    }
    .pic {
      margin-bottom: 8vh;
      width: 100%;
      display: flex;
      justify-content: center;
      .evm {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 6vh;
        img {
          margin-bottom: 2vh;
          width: 140px;
          height: 140px;
        }
        span {
          text-align: center;
          color: #999;
        }
      }
      .evm:last-child{
        margin-right: 0;
      }
    }
    .liaojie {
      width: 18vh;
      height: 5vh;
      background-color: #08a579;
      text-align: center;
      color: #fff;
      line-height: 5vh;
      font-size: 14px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>